import {IArtistsStore} from './artists.interface';

export const artistsStoreInitialState: IArtistsStore = {
  followedArtistIds: [],
};
